import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FiCalendar, FiCamera, FiCheckCircle, FiGrid, FiList, FiLock, FiLogOut, FiShield, FiStar, FiUser } from "react-icons/fi";
import favicon from "../assets/favicon.png";
import { BASE_URL, hospitalPost } from "../utils/hospitalApi";

const HospitalProfile = () => {
  const navigate = useNavigate();
  const [hospital, setHospital] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("hospital_user") || "{}");
    } catch {
      return {};
    }
  });
  const [uploading, setUploading] = useState(false);
  const profileImage = `${BASE_URL}assets/hospital/${hospital.foto || "user.png"}`;

  const logout = () => {
    localStorage.removeItem("hospital_user_id");
    localStorage.removeItem("hospital_user");
    navigate("/");
  };

  const handleProfileImage = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("hospital_user_id", hospital.hospital_user_id || localStorage.getItem("hospital_user_id") || "");
    formData.append("foto", file);
    setUploading(true);
    const res = await hospitalPost("hospital-update-profile-image", formData);
    setUploading(false);
    if (res.data.status === 1) {
      const nextHospital = { ...hospital, foto: res.data.foto, foto_url: res.data.foto_url };
      setHospital(nextHospital);
      localStorage.setItem("hospital_user", JSON.stringify(nextHospital));
      toast.success(res.data.msg || "Profile image updated");
    } else {
      toast.error(res.data.msg || "Unable to update profile image");
    }
    event.target.value = "";
  };



  return (
    <div className="hospital-shell">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
        .hospital-shell { min-height:100vh; background:#edf3f7; font-family:'Nunito','DM Sans',sans-serif; color:#102033; display:flex; }
        .h-sidebar { width:118px; background:#07182e; color:#fff; min-height:100vh; position:sticky; top:0; align-self:flex-start; box-shadow:10px 0 28px rgba(15,23,42,.10); z-index:5; }
        .h-brand { height:68px; display:flex; align-items:center; justify-content:center; border-bottom:1px solid rgba(255,255,255,.09); }
        .h-brand img { width:34px; height:34px; object-fit:contain; }
        .h-nav { display:flex; flex-direction:column; padding:0; }
        .h-nav button { min-height:84px; border:0; background:transparent; color:#fff; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:8px; padding:10px; font-size:13px; font-weight:900; border-bottom:1px solid rgba(255,255,255,.10); cursor:pointer; }
        .h-nav button.is-active, .h-nav button:hover { background:#fff; color:#0f172a; }
        .h-nav button svg { font-size:24px; color:#9ee7dc; }
        .h-nav button.is-active svg, .h-nav button:hover svg { color:#0f172a; }
        .h-sidebar-logout { position:absolute; left:10px; right:10px; bottom:12px; }
        .h-main { flex:1; min-width:0; }
        .h-topbar { height:66px; background:#07182e; color:#fff; display:flex; align-items:center; justify-content:space-between; padding:0 20px; box-shadow:0 6px 18px rgba(15,23,42,.12); }
        .h-top-title { display:flex; align-items:center; gap:8px; font-size:20px; font-weight:900; letter-spacing:.4px; }
        .h-top-profile { display:flex; align-items:center; gap:10px; }
        .h-avatar { width:42px; height:42px; border-radius:50%; background:linear-gradient(135deg,#14b8a6,#0f766e); color:#fff; display:flex; align-items:center; justify-content:center; font-size:16px; font-weight:900; border:3px solid rgba(255,255,255,.16); overflow:hidden; }
        .h-avatar img { width:100%; height:100%; object-fit:cover; }
        .h-content { padding:18px 18px 64px; }
        .profile-layout { display:grid; grid-template-columns:360px 1fr; gap:18px; align-items:start; }
        .profile-card, .info-card { background:#fff; border:1px solid #e2e8f0; border-radius:22px; box-shadow:0 14px 38px rgba(15,23,42,.08); overflow:hidden; }
        .profile-cover { height:110px; background:linear-gradient(135deg,#4aa394,#1f7a45); }
        .profile-main { padding:0 24px 26px; }
        .profile-photo-wrap { width:112px; height:112px; margin-top:-56px; position:relative; }
        .profile-photo { width:112px; height:112px; border-radius:50%; border:5px solid #fff; background:#f1f5f9; display:flex; align-items:center; justify-content:center; color:#0f766e; font-size:34px; font-weight:900; overflow:hidden; box-shadow:0 10px 26px rgba(15,23,42,.18); }
        .profile-photo img { width:100%; height:100%; object-fit:cover; }
        .photo-upload { position:absolute; right:-4px; bottom:4px; width:34px; height:34px; border-radius:50%; background:#ff8a00; color:#fff; display:flex; align-items:center; justify-content:center; cursor:pointer; box-shadow:0 8px 18px rgba(255,138,0,.35); }
        .photo-upload input { display:none; }
        .status-pill { float:right; margin-top:-20px; display:inline-flex; align-items:center; gap:7px; padding:8px 15px; border-radius:999px; background:#dcfce7; color:#15803d; font-size:12px; font-weight:900; }
        .profile-name { margin:18px 0 4px; font-size:23px; font-weight:900; color:#07182e; }
        .profile-sub { color:#526987; font-size:13px; font-weight:900; }
        .profile-divider { height:1px; background:#e2e8f0; margin:22px 0 14px; }
        .section-kicker { color:#9aa4b5; font-size:11px; font-weight:900; text-transform:uppercase; letter-spacing:.8px; margin-bottom:12px; }
        .profile-info-list { display:grid; gap:0; }
        .profile-info-row { display:grid; grid-template-columns:44px 1fr; gap:10px; padding:13px 0; border-bottom:1px solid #edf2f7; align-items:center; }
        .profile-info-row:last-child { border-bottom:0; }
        .info-icon { width:40px; height:40px; border-radius:13px; display:flex; align-items:center; justify-content:center; color:#fff; font-size:18px; }
        .info-icon.teal { background:#0f9f8f; } .info-icon.green { background:#45ad4d; } .info-icon.purple { background:#9c27b0; } .info-icon.cream { background:#fff1ca; color:#d48a00; }
        .mini-label { color:#9aa4b5; font-size:11px; font-weight:900; text-transform:uppercase; letter-spacing:.5px; }
        .mini-value { color:#07182e; font-size:14px; font-weight:900; margin-top:3px; }
        .info-card { padding:24px; margin-bottom:16px; }
        .card-title { display:flex; align-items:center; gap:12px; color:#9aa4b5; font-size:12px; font-weight:900; text-transform:uppercase; letter-spacing:.8px; margin-bottom:22px; }
        .title-icon { width:38px; height:38px; border-radius:14px; background:#e6fffb; color:#0f766e; display:flex; align-items:center; justify-content:center; font-size:19px; }
        .detail-row { display:flex; align-items:center; justify-content:space-between; gap:16px; padding:15px 0; border-bottom:1px solid #e8eef5; font-size:14px; }
        .detail-row:last-child { border-bottom:0; }
        .detail-label { color:#526987; font-weight:900; }
        .detail-value { color:#07182e; font-weight:900; text-align:right; }
        .detail-value.active { color:#15803d; }
        .tips-list { display:grid; gap:12px; }
        .tip-row { display:grid; grid-template-columns:44px 1fr; gap:14px; align-items:center; border:1px solid #e4ebf3; background:#f8fafc; border-radius:16px; padding:13px 14px; color:#13233b; font-weight:900; }
        .tip-icon { width:44px; height:44px; border-radius:13px; display:flex; align-items:center; justify-content:center; color:#fff; }
        .tip-icon.teal { background:#0f9f8f; } .tip-icon.green { background:#45ad4d; } .tip-icon.blue { background:#2898e8; } .tip-icon.gold { background:#fff1ca; color:#f59e0b; }
        .h-btn { display:inline-flex; align-items:center; justify-content:center; gap:6px; border:none; border-radius:9px; padding:9px 13px; font-size:12px; font-weight:900; cursor:pointer; white-space:nowrap; }
        .h-btn-danger { background:#fee2e2; color:#dc2626; width:100%; min-height:42px; }
        .h-footer { position:fixed; left:118px; right:0; bottom:0; height:46px; background:#fff; border-top:1px solid #e5e7eb; display:flex; align-items:center; justify-content:center; z-index:4; color:#8a94a6; font-size:12px; font-weight:700; box-shadow:0 -6px 18px rgba(15,23,42,.06); }
        .h-footer strong { color:#f05a00; font-weight:900; }
        @media (max-width:1100px) { .profile-layout { grid-template-columns:1fr; } }
        @media (max-width:980px) { .h-footer { left:0; } .hospital-shell { display:block; } .h-sidebar { position:relative; width:100%; min-height:auto; display:flex; align-items:center; } .h-sidebar-logout { position:static; padding:10px; min-width:118px; } .h-brand { width:140px; height:66px; } .h-nav { flex:1; flex-direction:row; overflow:auto; } .h-nav button { min-height:66px; min-width:112px; } .h-topbar { height:auto; padding:12px; } }
        @media (max-width:560px) { .h-content { padding:10px 10px 64px; } .profile-main, .info-card { padding:18px; } .detail-row { align-items:flex-start; flex-direction:column; gap:5px; } .detail-value { text-align:left; } }
      `}</style>

      <aside className="h-sidebar">
        <div className="h-brand"><img src={favicon} alt="Sat Kartar" /></div>
        <nav className="h-nav">
          <button type="button" onClick={() => navigate("/dashboard")}><FiGrid /> Dashboard</button>
          <button type="button" onClick={() => navigate("/appointments")}><FiList /> Appointment List</button>
          <button className="is-active" type="button"><FiUser /> My Profile</button>
        </nav>
        <div className="h-sidebar-logout"><button className="h-btn h-btn-danger" onClick={logout}><FiLogOut size={14} /> Logout</button></div>
      </aside>

      <main className="h-main">
        <header className="h-topbar">
          <div className="h-top-title"><span style={{ color: "#ff4b21" }}>SAT KARTAR</span><span style={{ color: "#61a5ff" }}>SANJEEVAN</span></div>
          <div className="h-top-profile"><div className="h-avatar"><img src={profileImage} alt="Profile" onError={(e) => { e.currentTarget.src = `${BASE_URL}assets/hospital/user.png`; }} /></div></div>
        </header>

        <div className="h-content">
          <div className="profile-layout">
            <section className="profile-card">
              <div className="profile-cover" />
              <div className="profile-main">
                <span className="status-pill"><FiCheckCircle /> Active</span>
                <div className="profile-photo-wrap">
                  <div className="profile-photo"><img src={profileImage} alt="Profile" onError={(e) => { e.currentTarget.src = `${BASE_URL}assets/hospital/user.png`; }} /></div>
                  <label className="photo-upload" title="Change profile image"><FiCamera size={16} /><input type="file" accept="image/*" onChange={handleProfileImage} disabled={uploading} /></label>
                </div>
                <h1 className="profile-name">{hospital.hospital_name || "Hospital User"}</h1>
                <div className="profile-sub">Hospital Panel - {hospital.hospital_code || "Not Available"}{uploading ? " | Uploading..." : ""}</div>
                <div className="profile-divider" />
                <div className="section-kicker">Profile Information</div>
                <div className="profile-info-list">
                  <div className="profile-info-row"><div className="info-icon teal"><FiUser /></div><div><div className="mini-label">Full Name</div><div className="mini-value">{hospital.hospital_name || "-"}</div></div></div>
                  <div className="profile-info-row"><div className="info-icon green"><FiShield /></div><div><div className="mini-label">Hospital Code</div><div className="mini-value">{hospital.hospital_code || "-"}</div></div></div>
                  <div className="profile-info-row"><div className="info-icon purple"><FiGrid /></div><div><div className="mini-label">User ID</div><div className="mini-value">{hospital.hospital_user_id || localStorage.getItem("hospital_user_id") || "-"}</div></div></div>
                  <div className="profile-info-row"><div className="info-icon cream"><FiCalendar /></div><div><div className="mini-label">Created Date</div><div className="mini-value">Not Available</div></div></div>
                </div>
              </div>
            </section>

            <div>
              <section className="info-card">
                <div className="card-title"><span className="title-icon"><FiShield /></span> Account Details</div>
                <div className="detail-row"><div className="detail-label">Account Type</div><div className="detail-value">Hospital Panel</div></div>
                <div className="detail-row"><div className="detail-label">Account Status</div><div className="detail-value">Active</div></div>
                <div className="detail-row"><div className="detail-label">Hospital Code</div><div className="detail-value">{hospital.hospital_code || "-"}</div></div>
                <div className="detail-row"><div className="detail-label">Platform</div><div className="detail-value">Sat Kartar Life Limited</div></div>
              </section>

              <section className="info-card">
                <div className="card-title"><span className="title-icon" style={{ background: "#fff1ca", color: "#f59e0b" }}><FiStar /></span> Tips & Reminders</div>
                <div className="tips-list">
                  <div className="tip-row"><div className="tip-icon teal"><FiCheckCircle /></div><div>Keep your profile details updated for smooth patient follow-up.</div></div>
                  <div className="tip-row"><div className="tip-icon green"><FiShield /></div><div>Use your own login only and logout from shared systems.</div></div>
                  <div className="tip-row"><div className="tip-icon blue"><FiLock /></div><div>Never share your password or login details with anyone.</div></div>
                  <div className="tip-row"><div className="tip-icon gold"><FiStar /></div><div>Review patient appointments regularly from your dashboard.</div></div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <footer className="h-footer"><strong>&copy; 2026 Sat Kartar Life Limited.</strong>&nbsp; All Rights Reserved</footer>
      </main>
    </div>
  );
};

export default HospitalProfile;




